import css from 'styled-jsx/css';

export default css`
  .pc-model-overview-specs {
    background-color: transparent;
    border: none;
    color: #e4e4e4;
    font-family: 'Roboto-Medium';
    font-size: 13px;
    letter-spacing: 0;
    line-height: 20px;
    text-decoration: underline;
    cursor: pointer;
    padding: 0px;
    text-transform: capitalize;
    /* margin-left: 8px; */
  }
  .pc-model-overview-specs:hover {
    text-decoration: none;
    color: #fd0300;
  }
`;
